import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 信用评价申请单系统服务
 */
export class CreditEvaApplyController {
  constructor() {
    this.baseurl = 'CreditEvaApplyController.assx/';
  }

  /**
   * 添加不良信息申请单
   * token:String, badCreditEvaApply:BadCreditEvaApply, cantonCode:String, importantDocs:ImportantDocList, relationDocCode:String
   */
  AddBadCreditEvaApply(
    token,
    badCreditEvaApply,
    cantonCode,
    importantDocs,
    relationDocCode
  ) {
    return request.post(
      this.baseurl + 'AddBadCreditEvaApply',
      Qs.stringify({
        token: token,
        badCreditEvaApply:
          typeof badCreditEvaApply === 'undefined' || badCreditEvaApply === null
            ? ''
            : badCreditEvaApply.toString(),
        cantonCode: cantonCode,
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
        relationDocCode: relationDocCode,
      })
    );
  }
  /**
     * 
     * token:String, para:EaAreaQueryParaEx, startIndex:int, maxSize:int, resultTotalCount:boolean
     */
  getEaAreaInfoListByParam(token, para, startIndex, maxSize, resultTotalCount){
      return request.post(this.baseurl + 'getEaAreaInfoListByParam', Qs.stringify({ token:token, para:typeof para === 'undefined' || para === null ? '' : para.toString(), startIndex:startIndex, maxSize:maxSize, resultTotalCount:resultTotalCount }));
  }
  /**
   * 共有资金是否应开
   * area:String
   */
  getAreaCommonAccountOpen(area) {
    return request.post(
      this.baseurl + 'getAreaCommonAccountOpen',
      Qs.stringify({ area: area })
    );
  }

  /**
   * 获取项目经理在管物业区域列表
   * token:String, name:String, mob1:String, key:String
   */
  GetEaAreaListByManger(token, name, mob1, key) {
    return request.post(
      this.baseurl + 'GetEaAreaListByManger',
      Qs.stringify({ token: token, name: name, mob1: mob1, key: key })
    );
  }

  /**
   * 添加企业激励名单申请单
   * token:String, encourageListApply:EncourageListApply, importantDocs:ImportantDocList
   */
  AddEncourageListApply(token, encourageListApply, importantDocs) {
    return request.post(
      this.baseurl + 'AddEncourageListApply',
      Qs.stringify({
        token: token,
        encourageListApply:
          typeof encourageListApply === 'undefined' ||
          encourageListApply === null
            ? ''
            : encourageListApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }

  /**
   * 修改良好信息申请单
   * token:String, goodCreditEvaApply:GoodCreditEvaApply, importantDocs:ImportantDocList, applyNo:String
   */
  ModifyCreditEvaApply(token, goodCreditEvaApply, importantDocs, applyNo) {
    return request.post(
      this.baseurl + 'ModifyCreditEvaApply',
      Qs.stringify({
        token: token,
        goodCreditEvaApply:
          typeof goodCreditEvaApply === 'undefined' ||
          goodCreditEvaApply === null
            ? ''
            : goodCreditEvaApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
        applyNo: applyNo,
      })
    );
  }

  /**
   * 获取信息管理按钮状态
   * parameter:QueryVo
   */
  geInformationManagementVoBtn_public(parameter) {
    return request.post(
      this.baseurl + 'geInformationManagementVoBtn_public',
      Qs.stringify({
        parameter:
          typeof parameter === 'undefined' || parameter === null
            ? ''
            : parameter.toString(),
      })
    );
  }

  /**
   * 通过定时任务添加良好信息（自动采集）
   *
   */
  addGoodCreditEvaByScheduledTask() {
    return request.post(
      this.baseurl + 'addGoodCreditEvaByScheduledTask',
      Qs.stringify({})
    );
  }

  /**
   * 获取良好信息申请表详情
   * token:String, docCode:String
   */
  GetGoodCreditEvaApplyDetail(token, docCode) {
    return request.post(
      this.baseurl + 'GetGoodCreditEvaApplyDetail',
      Qs.stringify({ token: token, docCode: docCode })
    );
  }

  /**
   * 返回项目负责人和 所属公司
   * token:String, areaCode:String, manageName:String, startIndex:int, maxSize:int
   */
  querymanageInfoAndCommpanyInfo(
    token,
    areaCode,
    manageName,
    startIndex,
    maxSize
  ) {
    return request.post(
      this.baseurl + 'querymanageInfoAndCommpanyInfo',
      Qs.stringify({
        token: token,
        areaCode: areaCode,
        manageName: manageName,
        startIndex: startIndex,
        maxSize: maxSize,
      })
    );
  }

  /**
   * 获取风险名单信息申请表详情
   * token:String, docCode:String
   */
  GetRiskCreditEvaApplyDetail(token, docCode) {
    return request.post(
      this.baseurl + 'GetRiskCreditEvaApplyDetail',
      Qs.stringify({ token: token, docCode: docCode })
    );
  }

  /**
   * 测试
   * date:Date
   */
  Test(date) {
    return request.post(this.baseurl + 'Test', Qs.stringify({ date: date }));
  }

  /**
   * 添加异议信息申请单
   * token:String, dissentCreditEvaApply:DissentCreditEvaApply, cantonCode:String, orgName:String, mangerName:String, suitObj:int, importantDocs:ImportantDocList, tittle:String
   */
  AddDissentCreditEvaApply(
    token,
    dissentCreditEvaApply,
    cantonCode,
    orgName,
    mangerName,
    suitObj,
    importantDocs,
    tittle
  ) {
    return request.post(
      this.baseurl + 'AddDissentCreditEvaApply',
      Qs.stringify({
        token: token,
        dissentCreditEvaApply:
          typeof dissentCreditEvaApply === 'undefined' ||
          dissentCreditEvaApply === null
            ? ''
            : dissentCreditEvaApply.toString(),
        cantonCode: cantonCode,
        orgName: orgName,
        mangerName: mangerName,
        suitObj: suitObj,
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
        tittle: tittle,
      })
    );
  }

  /**
   * 获取事项配置内容
   * token:String, ruleItemNo:String
   */
  GetCreditEvaScoreGroupItem(token, ruleItemNo) {
    return request.post(
      this.baseurl + 'GetCreditEvaScoreGroupItem',
      Qs.stringify({ token: token, ruleItemNo: ruleItemNo })
    );
  }

  /**
   * 获取项目经理在管物业区域
   * token:String, name:String, mob1:String
   */
  GetEaAreaByManger(token, name, mob1) {
    return request.post(
      this.baseurl + 'GetEaAreaByManger',
      Qs.stringify({ token: token, name: name, mob1: mob1 })
    );
  }

  /**
   * 获取良好配置内容
   * token:String, ruleItemNo:String, level:String, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetGoodCreditEvaScoreItemList(
    token,
    ruleItemNo,
    level,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetGoodCreditEvaScoreItemList',
      Qs.stringify({
        token: token,
        ruleItemNo: ruleItemNo,
        level: level,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }

  /**
   * 删除自动获取的良好信息数据（包括绑定，视频）
   *
   */
  deleteAllAutoGoodInformation() {
    return request.post(
      this.baseurl + 'deleteAllAutoGoodInformation',
      Qs.stringify({})
    );
  }

  /**
   * 根据父事项编号获取不良配置规则子项
   * id:String
   */
  getBadCreditEvaScoreItemListById(id) {
    return request.post(
      this.baseurl + 'getBadCreditEvaScoreItemListById',
      Qs.stringify({ id: id })
    );
  }

  /**
   * 定时刷新物化视图
   *
   */
  refreshMView() {
    return request.post(this.baseurl + 'refreshMView', Qs.stringify({}));
  }

  /**
   * 获取信息申请单列表（异议）
   * token:String, applyCode:String, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int
   */
  GetCreditEvaApplyByDissent(
    token,
    applyCode,
    startIndex,
    maxSize,
    resultTotalCount,
    option
  ) {
    return request.post(
      this.baseurl + 'GetCreditEvaApplyByDissent',
      Qs.stringify({
        token: token,
        applyCode: applyCode,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        option: option,
      })
    );
  }

  /**
   * 添加良好信息申请单
   * token:String, goodCreditEvaApply:GoodCreditEvaApply, importantDocs:ImportantDocList
   */
  AddGoodCreditEvaApply(token, goodCreditEvaApply, importantDocs) {
    return request.post(
      this.baseurl + 'AddGoodCreditEvaApply',
      Qs.stringify({
        token: token,
        goodCreditEvaApply:
          typeof goodCreditEvaApply === 'undefined' ||
          goodCreditEvaApply === null
            ? ''
            : goodCreditEvaApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }

  /**
   * 查询企业激励名单指标信息
   * token:String, years:String, orgCode:String, ywdbh:String
   */
  SelectEncourageListOrgInfo(token, years, orgCode, ywdbh) {
    return request.post(
      this.baseurl + 'SelectEncourageListOrgInfo',
      Qs.stringify({
        token: token,
        years: years,
        orgCode: orgCode,
        ywdbh: ywdbh,
      })
    );
  }

  /**
   * 获取信息管理列表列表
   * token:String, parameter:QueryVo, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int
   */
  GetInformationManagementVoList(
    token,
    parameter,
    startIndex,
    maxSize,
    resultTotalCount,
    option
  ) {
    return request.post(
      this.baseurl + 'GetInformationManagementVoList',
      Qs.stringify({
        token: token,
        parameter:
          typeof parameter === 'undefined' || parameter === null
            ? ''
            : parameter.toString(),
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        option: option,
      })
    );
  }

  /**
   * 获取信息管理列表列表
   * parameter:QueryVo, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int, valueMethod:Integer
   */
  getInformationManagementVoList_builtBureauWebsite(
    parameter,
    startIndex,
    maxSize,
    resultTotalCount,
    option,
    valueMethod
  ) {
    return request.post(
      this.baseurl + 'getInformationManagementVoList_builtBureauWebsite',
      Qs.stringify({
        parameter:
          typeof parameter === 'undefined' || parameter === null
            ? ''
            : parameter.toString(),
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        option: option,
        valueMethod: valueMethod,
      })
    );
  }

  /**
   * 获取不良信息申请表详情
   * token:String, docCode:String
   */
  GetBadCreditEvaApplyDetail(token, docCode) {
    return request.post(
      this.baseurl + 'GetBadCreditEvaApplyDetail',
      Qs.stringify({ token: token, docCode: docCode })
    );
  }

  /**
   * 获取临时良好信息得分
   *
   */
  getTemporaryGoodScore() {
    return request.post(
      this.baseurl + 'getTemporaryGoodScore',
      Qs.stringify({})
    );
  }

  /**
   * 获取不良配置内容
   * token:String, ruleItemNo:String, level:String, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetBadCreditEvaScoreItemList(
    token,
    ruleItemNo,
    level,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetBadCreditEvaScoreItemList',
      Qs.stringify({
        token: token,
        ruleItemNo: ruleItemNo,
        level: level,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }

  /**
   * 获取信息管理列表列表
   * token:String, parameter:QueryVo, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int, valueMethod:Integer
   */
  getInformationManagementVoList_public(
    token,
    parameter,
    startIndex,
    maxSize,
    resultTotalCount,
    option,
    valueMethod
  ) {
    return request.post(
      this.baseurl + 'getInformationManagementVoList_public',
      Qs.stringify({
        token: token,
        parameter:
          typeof parameter === 'undefined' || parameter === null
            ? ''
            : parameter.toString(),
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        option: option,
        valueMethod: valueMethod,
      })
    );
  }

  /**
   * 获取信息申请单列表
   * token:String, operatorName:String, applyType:String, status:int, startIndex:int, maxSize:int, resultTotalCount:boolean, applyCode:String
   */
  GetCreditEvaApply(
    token,
    operatorName,
    applyType,
    status,
    startIndex,
    maxSize,
    resultTotalCount,
    applyCode
  ) {
    return request.post(
      this.baseurl + 'GetCreditEvaApply',
      Qs.stringify({
        token: token,
        operatorName: operatorName,
        applyType: applyType,
        status: status,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        applyCode: applyCode,
      })
    );
  }

  /**
   * 获取关联审批事项列表
   * token:String, docCode:String, applyCode:String, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetApprovalRelatedItemsVoList(
    token,
    docCode,
    applyCode,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetApprovalRelatedItemsVoList',
      Qs.stringify({
        token: token,
        docCode: docCode,
        applyCode: applyCode,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }

  /**
   * 判断企业激励名单申请，是否在申报时间内
   * token:String, years:String, orgCode:String
   */
  IsCanAddEncourageList(token, years, orgCode) {
    return request.post(
      this.baseurl + 'IsCanAddEncourageList',
      Qs.stringify({ token: token, years: years, orgCode: orgCode })
    );
  }

  /**
   * 是否显示提示文字
   * token:String, goodCreditEvaApply:GoodCreditEvaApply
   */
  CheckRole(token, goodCreditEvaApply) {
    return request.post(
      this.baseurl + 'CheckRole',
      Qs.stringify({
        token: token,
        goodCreditEvaApply:
          typeof goodCreditEvaApply === 'undefined' ||
          goodCreditEvaApply === null
            ? ''
            : goodCreditEvaApply.toString(),
      })
    );
  }

  /**
   * 通过定时任务添加良好信息（自动采集）业主绑定率
   *
   */
  addGoodCreditEvaByScheduledTaskByBind() {
    return request.post(
      this.baseurl + 'addGoodCreditEvaByScheduledTaskByBind',
      Qs.stringify({})
    );
  }

  /**
   * 撤回信息申请单
   * token:String, docCode:String, applyNo:String
   */
  RevokeCreditEvaApply(token, docCode, applyNo) {
    return request.post(
      this.baseurl + 'RevokeCreditEvaApply',
      Qs.stringify({ token: token, docCode: docCode, applyNo: applyNo })
    );
  }

  /**
   * 获取异议信息申请表详情
   * token:String, docCode:String
   */
  GetDissentCreditEvaApplyDetail(token, docCode) {
    return request.post(
      this.baseurl + 'GetDissentCreditEvaApplyDetail',
      Qs.stringify({ token: token, docCode: docCode })
    );
  }

  /**
   * 通过定时任务添加良好信息（自动采集）项目负责人加分，企业也相应得到加分
   *
   */
  addGoodCreditEvaByScheduledTaskByManager() {
    return request.post(
      this.baseurl + 'addGoodCreditEvaByScheduledTaskByManager',
      Qs.stringify({})
    );
  }

  /**
   * 获取机构代码和机构名称
   * token:String
   */
  GetOrgInfo(token) {
    return request.post(
      this.baseurl + 'GetOrgInfo',
      Qs.stringify({ token: token })
    );
  }

  /**
   * 获取当前企业以及下属企业的物业项目
   * token:String, orgCode:String, eaAreaName:String, startIndex:int, maxSize:int
   */
  GetEaAreaCodeNameByOrg(token, orgCode, eaAreaName, startIndex, maxSize) {
    return request.post(
      this.baseurl + 'GetEaAreaCodeNameByOrg',
      Qs.stringify({
        token: token,
        orgCode: orgCode,
        eaAreaName: eaAreaName,
        startIndex: startIndex,
        maxSize: maxSize,
      })
    );
  }

  /**
   * 获取业务单是否存在异议信息
   * token:String, docCode:String
   */
  GetDissentInfo(token, docCode) {
    return request.post(
      this.baseurl + 'GetDissentInfo',
      Qs.stringify({ token: token, docCode: docCode })
    );
  }

  /**
   * 通过定时任务添加良好信息（自动采集）绿色物业
   *
   */
  addGoodCreditEvaByScheduledTaskByGreen() {
    return request.post(
      this.baseurl + 'addGoodCreditEvaByScheduledTaskByGreen',
      Qs.stringify({})
    );
  }

  /**
   * 获取物业区域信息
   * token:String, orgCode:String, eaAreaName:String, startIndex:int, maxSize:int, resultTotalCount:boolean
   */
  GetEaAreaInfoList(
    token,
    orgCode,
    eaAreaName,
    startIndex,
    maxSize,
    resultTotalCount
  ) {
    return request.post(
      this.baseurl + 'GetEaAreaInfoList',
      Qs.stringify({
        token: token,
        orgCode: orgCode,
        eaAreaName: eaAreaName,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
      })
    );
  }

  /**
   * 修改风险信息申请单
   * token:String, riskCreditEvaApply:RiskCreditEvaApply, importantDocs:ImportantDocList
   */
  ModifyRiskCreditEvaApply(token, riskCreditEvaApply, importantDocs) {
    return request.post(
      this.baseurl + 'ModifyRiskCreditEvaApply',
      Qs.stringify({
        token: token,
        riskCreditEvaApply:
          typeof riskCreditEvaApply === 'undefined' ||
          riskCreditEvaApply === null
            ? ''
            : riskCreditEvaApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }

  /**
   * 补录任务 执行状态为 开始或结束
   *
   */
  updateInformationSupplementTaskStatus() {
    return request.post(
      this.baseurl + 'updateInformationSupplementTaskStatus',
      Qs.stringify({})
    );
  }

  /**
   * 获取总公司/分公司
   * orgCode:String
   */
  getParentRealtyMgeComByOrgCode(orgCode) {
    return request.post(
      this.baseurl + 'getParentRealtyMgeComByOrgCode',
      Qs.stringify({ orgCode: orgCode })
    );
  }

  /**
   * 修改激励名单申请单
   * token:String, encourageListApply:EncourageListApply, importantDocs:ImportantDocList, applyNo:String
   */
  ModifyEncourageListApply(token, encourageListApply, importantDocs, applyNo) {
    return request.post(
      this.baseurl + 'ModifyEncourageListApply',
      Qs.stringify({
        token: token,
        encourageListApply:
          typeof encourageListApply === 'undefined' ||
          encourageListApply === null
            ? ''
            : encourageListApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
        applyNo: applyNo,
      })
    );
  }

  /**
   * 获取激励名单申请表详情
   * token:String, docCode:String
   */
  GetEncourageListApplyDetail(token, docCode) {
    return request.post(
      this.baseurl + 'GetEncourageListApplyDetail',
      Qs.stringify({ token: token, docCode: docCode })
    );
  }

  /**
   * 获取机构代码和机构名称(主管部门)
   * token:String, orgName:String, startIndex:int, maxSize:int, resultTotalCount:boolean, relationsIsNull:Integer
   */
  GetOrgInfoByTop(
    token,
    orgName,
    startIndex,
    maxSize,
    resultTotalCount,
    relationsIsNull
  ) {
    return request.post(
      this.baseurl + 'GetOrgInfoByTop',
      Qs.stringify({
        token: token,
        orgName: orgName,
        startIndex: startIndex,
        maxSize: maxSize,
        resultTotalCount: resultTotalCount,
        relationsIsNull: relationsIsNull,
      })
    );
  }

  /**
   * 添加风险名单信息申请单
   * token:String, riskCreditEvaApply:RiskCreditEvaApply, cantonCode:String, importantDocs:ImportantDocList
   */
  AddRiskCreditEvaApply(token, riskCreditEvaApply, cantonCode, importantDocs) {
    return request.post(
      this.baseurl + 'AddRiskCreditEvaApply',
      Qs.stringify({
        token: token,
        riskCreditEvaApply:
          typeof riskCreditEvaApply === 'undefined' ||
          riskCreditEvaApply === null
            ? ''
            : riskCreditEvaApply.toString(),
        cantonCode: cantonCode,
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }

  /**
   * 修改不良信息申请单
   * token:String, badCreditEvaApply:BadCreditEvaApply, importantDocs:ImportantDocList
   */
  ModifyBadCreditEvaApply(token, badCreditEvaApply, importantDocs) {
    return request.post(
      this.baseurl + 'ModifyBadCreditEvaApply',
      Qs.stringify({
        token: token,
        badCreditEvaApply:
          typeof badCreditEvaApply === 'undefined' || badCreditEvaApply === null
            ? ''
            : badCreditEvaApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
      })
    );
  }

  /**
   * 修改异议信息申请单
   * token:String, dissentCreditEvaApply:DissentCreditEvaApply, suitObj:int, importantDocs:ImportantDocList, applyNo:String
   */
  ModifyDissentCreditEvaApply(
    token,
    dissentCreditEvaApply,
    suitObj,
    importantDocs,
    applyNo
  ) {
    return request.post(
      this.baseurl + 'ModifyDissentCreditEvaApply',
      Qs.stringify({
        token: token,
        dissentCreditEvaApply:
          typeof dissentCreditEvaApply === 'undefined' ||
          dissentCreditEvaApply === null
            ? ''
            : dissentCreditEvaApply.toString(),
        suitObj: suitObj,
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
        applyNo: applyNo,
      })
    );
  }

  /**
   * 主管部门良好信息录入
   * token:String, goodCreditEvaApply:GoodCreditEvaApply, importantDocs:ImportantDocList, relationRecords:String, validDate:Long
   */
  manageAddGoodCreditEvaApply(
    token,
    goodCreditEvaApply,
    importantDocs,
    relationRecords,
    validDate
  ) {
    return request.post(
      this.baseurl + 'manageAddGoodCreditEvaApply',
      Qs.stringify({
        token: token,
        goodCreditEvaApply:
          typeof goodCreditEvaApply === 'undefined' ||
          goodCreditEvaApply === null
            ? ''
            : goodCreditEvaApply.toString(),
        importantDocs:
          typeof importantDocs === 'undefined' || importantDocs === null
            ? ''
            : importantDocs.toString(),
        relationRecords: relationRecords,
        validDate: validDate,
      })
    );
  }
  /**
   * 主管部门良好信息录入
   * token:String, goodCreditEvaApply:GoodCreditEvaApply, importantDocs:ImportantDocList, relationRecords:String, validDate:Long
   */
  selectOrgInfoByOrg(token, orgCode) {
    return request.post(
      this.baseurl + 'selectOrgInfoByOrg',
      Qs.stringify({ token: token, orgCode })
    );
  }
  /**
     * 获取物业区域信息-意愿征集
     * token:String, para:EaAreaQueryParaEx, start:int, size:int, isPage:boolean
     */
  getWishEaAreaInfoVoList(token, para, start, size, isPage){
    return request.post(this.baseurl + 'getWishEaAreaInfoVoList', Qs.stringify({ token:token, para:typeof para === 'undefined' || para === null ? '' : para.toString(), start:start, size:size, isPage:isPage }));
  }

  /**
   * 查询企业激励名单审核信息
   * @param {*} token 
   * @param {*} year 
   * @param {*} orgCode 
   * @returns 
   */
  selectEncourageListYwdByOrg(token,year, orgCode) {
    return request.post(
      this.baseurl + 'SelectEncourageListYwdByOrg',
      Qs.stringify({ token: token,years:year, orgCode:orgCode })
    );
  }

  /**
   * 获取年度风险名单批次列表
   * @param {*} token 
   * @param {*} riskYearName 
   * @param {*} startIndex 
   * @param {*} maxSize 
   * @param {*} resultTotalCount 
   * @returns 
   */
  getRiskYearAutoList(token, riskYearName, startIndex, maxSize, resultTotalCount){
    return request.post(
      this.baseurl + 'getRiskYearAutoList',
      Qs.stringify({ token: token,riskYearName:riskYearName, startIndex:startIndex,maxSize:maxSize, resultTotalCount:resultTotalCount})
    );
  }

  /**
   * 获取风险名单列表
   * @param {*} token 
   * @param {*} riskYearId 
   * @param {*} orgName 
   * @param {*} managerName 
   * @param {*} state 
   * @param {*} startIndex 
   * @param {*} maxSize 
   * @param {*} resultTotalCount 
   * @returns 
   */
  getRiskYearListByOrgOrManager(token, riskYearId,orgName,managerName,state, startIndex, maxSize, resultTotalCount){
    return request.post(
      this.baseurl + 'getRiskYearListByOrgOrManager',
      Qs.stringify({ token: token,riskYearId:riskYearId,orgName:orgName,managerName:managerName,state:state, startIndex:startIndex,maxSize:maxSize, resultTotalCount:resultTotalCount})
    );
  }

  /**
   * 移除/恢复 风险名单
   * @param {*} token 
   * @param {*} state 
   * @returns 
   */
  removeRiskYear(token,state,keyIds) {
    return request.post(
      this.baseurl + 'removeRiskYear',
      Qs.stringify({ token: token,state:state,keyIds:keyIds.toString()})
    );
  }

  /**
   * 提交调整名单
   * @param {*} token 
   * @param {*} riskYearId 
   * @param {*} remark 
   * @returns 
   */
  addRiskYearApply(token,riskYearId,remark) {
    return request.post(
      this.baseurl + 'addRiskYearApply',
      Qs.stringify({ token: token,riskYearId:riskYearId,remark:remark})
    );
  }

  /**
   * 查询风险名单详情
   * @param {*} token 
   * @param {*} orgCode 
   * @param {*} managerTel 
   * @param {*} managerName 
   * @param {*} bodyType 
   * @param {*} year 
   * @returns 
   */
  getRiskYearInfo(token,orgCode,managerTel,managerName,bodyType,year) {
    return request.post(
      this.baseurl + 'getRiskYearInfo',
      Qs.stringify({ token: token,orgCode:orgCode,managerTel:managerTel,managerName:managerName,bodyType:bodyType,year:year})
    );
  }

}
